import { Component } from '@angular/core';
import { StageService } from '../services/stage-modal.service';

@Component({
  selector: 'queoval-stage-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})

/*
* Composant pour l'affichage des editions
*/
export class StageReportingComponent  {

  // #region CONSTRUCTEUR

  constructor(
    public service: StageService,  
  ) { }

  // #endregion
}
